import { CommonGet, CommonPost } from "../../../utils/CommonFetch";
import tokenDecoder from '../../../components/Common/tokenDecoder';

export default {

    getGroups,
    getAllOperationEntitiesForDropDown,
    saveVehicleRegistration,
    GetAllOperationEntityByGroupID,
    GetAllVehicleRegistration,
    updateVehicleRegistration,

};
async function GetAllVehicleRegistration(model) {
    const response = await CommonPost('/api/VehicleRegistration/GetVehicleRegistrationData', null, model);
    return response.data;
}

async function getGroups() {
    var groupArray = [];
    const response = await CommonGet('/api/Group/GetAllGroups', null);
    for (let item of Object.entries(response.data)) {
        if (item[1]["isActive"] === true) {
            groupArray[item[1]["groupID"]] = item[1]["groupName"];
        }
    }
    return groupArray;
}

async function getAllOperationEntitiesForDropDown(id) {
    var operationEntityArray = [];
    var response = await CommonGet('/api/OperationEntity/GetAllOperationEntities', null);
    for (let item of Object.entries(response.data)) {
        if (item[1]["groupID"] === parseInt(id) && item[1]["isActive"] === true)
            operationEntityArray[item[1]["operationEntityID"]] = item[1]["operationEntityName"];
    }
    return operationEntityArray;
}

async function saveVehicleRegistration(vehicleRegistration) {
    vehicleRegistration.createdBy = parseInt(tokenDecoder.getUserIDFromToken());
    vehicleRegistration.createdDate = new Date().toISOString();
    const response = await CommonPost('/api/VehicleRegistration/SaveVehicleRegistration', null, vehicleRegistration);
    return response;
}

async function updateVehicleRegistration(vehicleRegistration) {
    vehicleRegistration.createdBy = parseInt(tokenDecoder.getUserIDFromToken());
    vehicleRegistration.createdDate = new Date().toISOString();
    const response = await CommonPost('/api/VehicleRegistration/UpdateVehicleRegistration', null, vehicleRegistration);
    return response;
}


async function GetAllOperationEntityByGroupID(groupID) {
    const dataArray = [];
    const response = await CommonGet('/api/OperationEntity/GetAllOperationEntityByGroupID', 'groupID=' + groupID);
    for (let item of Object.entries(response.data)) {
        dataArray[item[1]["operationEntityID"]] = item[1]["operationEntityName"]
    }
    return dataArray;
}





